import(/* webpackMode: "eager", webpackExports: ["ToolsExplorer"] */ "C:\\Users\\graha\\source\\repos\\product-factory\\products\\01-rams\\web\\components\\ToolsExplorer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "C:\\Users\\graha\\source\\repos\\product-factory\\products\\01-rams\\web\\node_modules\\next\\dist\\client\\app-dir\\link.js");
